import { Button as ButtonBlock } from './Button';
export default ButtonBlock;
//# sourceMappingURL=index.js.mapimport { Button as ButtonBlock } from './Button';
export default ButtonBlock;
//# sourceMappingURL=index.js.map